module.exports = __webpack_public_path__ + "img/platform-logo-mv.bd1c3618.png";